<div class="login-page">
  <button type="button" class="theme-toggle login-theme-toggle" (click)="theme.toggle()"
    [attr.aria-label]="theme.toggleLabel" [attr.title]="theme.toggleLabel"
    [attr.aria-pressed]="theme.isDark">
    <i class="material-icons" aria-hidden="true">{{ theme.isDark ? 'light_mode' : 'dark_mode' }}</i>
  </button>
  <div class="login-card">
    <div class="login-header">
      <div class="login-icon">
        <i class="material-icons">account_balance</i>
      </div>
      <h2>CryptoExplorer</h2>
      <p class="login-subtitle">پنل مدیریت</p>
    </div>

    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="login-form">
      <div class="input-group-custom">
        <span class="input-icon">
          <i class="material-icons">person</i>
        </span>
        <input
          type="text"
          formControlName="username"
          placeholder="نام کاربری"
          [ngClass]="{ 'has-error': submitted && f.username.errors }"
        />
      </div>
      <div class="error-msg" *ngIf="submitted && f.username.errors">
        <span *ngIf="f.username.errors.required">نام کاربری الزامی است</span>
      </div>

      <div class="input-group-custom">
        <span class="input-icon">
          <i class="material-icons">lock</i>
        </span>
        <input
          type="password"
          formControlName="password"
          placeholder="کلمه عبور"
          [ngClass]="{ 'has-error': submitted && f.password.errors }"
        />
      </div>
      <div class="error-msg" *ngIf="submitted && f.password.errors">
        <span *ngIf="f.password.errors.required">کلمه عبور الزامی است</span>
      </div>

      <button type="submit" [disabled]="loading" class="login-btn">
        <span *ngIf="!loading">ورود</span>
        <span *ngIf="loading" class="spinner"></span>
      </button>
    </form>
  </div>
</div>
